import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { UpdateUserDTO } from "./type";

export async function updateUser(
  userId: string,
  data: UpdateUserDTO,
): Promise<void> {
  await apiClient.patch(apiPaths.users.update(userId), data);
}
